import { Group, Paper, Stack, Text } from '@mantine/core';
import { Link } from '@tanstack/react-router';

import { PublicationCardIdentifiers } from '@/module/Author/Publication/components/PublicationCardIdentifiers';
import { PublicationTitle } from '@/module/Author/Publication/components/PublicationTitle';

import { BdiList, JournalVolume, LanguagePill, NoOfAuthors, PublishedAtText } from '@feature/utils';

import { Review } from './../../model/ReviewTypes';
import classes from './ReviewCard.module.css';

export interface ReviewCardProps {
  review: Review;
  to: string;
}

export function ReviewCard({ review, to }: ReviewCardProps) {
  const {
    publishedAt,
    authors,
    language,
    noOfPages,
    volumeNo,
    volume,
    journal,
    startPage,
    endPage,
    identifiers,
    journalType,
    bdis,
  } = review;

  return (
    <Paper
      className={classes.card}
      component={Link}
      to={to}
      p="lg"
      c="var(--mantine-color-text)"
    >
      <Stack gap="xs">
        <PublicationTitle publication={review} />
        <Group>
          {journal && (
            <>
              <Text>
                {journal.title} {journalType?.name ? `(${journalType?.name})` : ''}
              </Text>
              <JournalVolume
                volume={volume}
                volumeNo={volumeNo}
                noOfPages={noOfPages}
                endPage={endPage}
                startPage={startPage}
              />
            </>
          )}
        </Group>
        <BdiList bdis={bdis} />
        <Group>
          <PublishedAtText
            date={publishedAt}
            size="sm"
            c="dimmed"
          />
          <NoOfAuthors authors={authors} />
        </Group>
        <Group>
          <LanguagePill language={language} />
          {identifiers && <PublicationCardIdentifiers identifiers={identifiers} />}
        </Group>
      </Stack>
    </Paper>
  );
}
